import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field, formValueSelector, reduxForm } from "redux-form";
import { Button, Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import api from "APP_ROOT/api";
import { toastr } from "react-redux-toastr";
import { RadioGroupField } from "MODULES/shared/components/Forms";
import { Body, Footer } from "MODULES/shared/components/Modal";
import { Icon } from "MODULES/shared/components";
import { LINE_ITEMS } from "APP_ROOT/constants";
import { SHIPPING_CHECKLIST } from "MODULES/shared/components/CommercialInvoice/helpers";

const formName = "send-wt-dims";

export class SendWeightDimsForm extends Component {
  static propTypes = {
    submitting: PropTypes.bool,
    id: PropTypes.number,
    lineItemIds: PropTypes.arrayOf(PropTypes.number),
    close: PropTypes.func.isRequired,
    weightsAndDims: PropTypes.number,
    weight: PropTypes.number,
    change: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired
  };

  state = {
    lineItems: [],
    hasWtDims: true,
    selectedLineItems: []
  };

  componentDidMount() {
    this.fetchLineItems(this.props.id);
  }

  onItemSelected = lineItem => {
    if (lineItem.id === null) {
      this.props.change(LINE_ITEMS, []);
      return;
    }

    const { lineItemIds } = this.props;
    const { selectedLineItems } = this.state;
    if (lineItemIds.includes(lineItem.id)) {
      const index = lineItemIds.indexOf(lineItem.id);
      lineItemIds.splice(index, 1);
      this.props.change(LINE_ITEMS, lineItemIds);
      this.setState({
        selectedLineItems: selectedLineItems.filter(
          item => item.id !== lineItem.id
        )
      });
    } else {
      lineItemIds.push(lineItem.id);
      this.props.change(LINE_ITEMS, lineItemIds);
      this.setState({
        selectedLineItems: selectedLineItems.concat([lineItem])
      });
    }
  };

  fetchLineItems = id => {
    api.salesOrders.show(id).then(resp => {
      const lineItems = resp.data.line_items;

      const state =
        lineItems.length === 1
          ? { lineItems, selectedLineItems: lineItems }
          : { lineItems };

      this.setState(state, () => {
        if (lineItems.length === 1) {
          this.props.change(LINE_ITEMS, lineItems.map(l => l.id));
        }

        this.setState({
          hasWtDims: Boolean(
            lineItems.find(
              item => item.part.width !== null || item.part.weight !== null
            )
          )
        });
      });
    });
  };

  renderRow = (lineItem, i) => (
    <tr key={i}>
      <td style={{ backgroundColor: "#383838" }}>{i + 1}</td>
      {lineItem.part.width ||
      lineItem.part.weight ||
      this.props.weightsAndDims.weight ||
      this.props.weightsAndDims.width ? (
        <td style={{ marginBottom: "6px" }}>
          <input
            name={LINE_ITEMS}
            type="checkbox"
            checked={this.state.selectedLineItems.includes(lineItem)}
            onChange={() => this.onItemSelected(lineItem)}
          />
        </td>
      ) : (
        <td />
      )}
      <td>{lineItem.part.part_number}</td>
      <td>{lineItem.serial_number}</td>
      <td>{lineItem.part.description}</td>
    </tr>
  );

  render() {
    const {
      submitting,
      close,
      weightsAndDims,
      weight,
      handleSubmit
    } = this.props;
    const { hasWtDims, lineItems, selectedLineItems } = this.state;

    const sendOptions =
      lineItems.length > 1
        ? [
            { text: "Ship as a single package", value: true },
            { text: "Ship in multiple packages", value: false }
          ]
        : [{ text: "Ship as a single package", value: true }];

    return (
      <form onSubmit={handleSubmit}>
        <Body>
          {!hasWtDims &&
            !Object.keys(weightsAndDims).some(k => weightsAndDims[k]) &&
            !weight && (
              <div className="alert alert-warning" role="alert">
                <div className="media">
                  <div className="media-left">
                    <i className="fa fa-lg fa-warning text-warning" />
                  </div>
                  <div className="media-body">
                    <strong>Warning!</strong> No WT and DIMs available for this
                    unit.
                  </div>
                </div>
              </div>
            )}
          <table className="table table-striped table-hover table-numbered">
            <thead>
              <tr>
                <th />
                <th />
                <th>Part Number</th>
                <th>Serial Number</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {lineItems.map((inv, idx) => this.renderRow(inv, idx))}
            </tbody>
          </table>
          <Row className="row-col-gutters-half">
            <Col md={8}>
              <Field
                name="ship_as_multiple"
                label="Shipping Options"
                component={RadioGroupField}
                options={sendOptions}
                required
              />
            </Col>
          </Row>
        </Body>
        <Footer>
          <button type="button" className="btn btn-default" onClick={close}>
            Cancel
          </button>
          <Button
            type="submit"
            bsStyle="primary"
            disabled={
              (!hasWtDims &&
                !Object.keys(weightsAndDims).some(k => weightsAndDims[k]) &&
                !weight) ||
              selectedLineItems.length === 0 ||
              submitting
            }
          >
            <Icon name="envelope" fixed />
            &nbsp;Yes, Send Wts and Dims
          </Button>
        </Footer>
      </form>
    );
  }
}

const selector = formValueSelector(formName);

export default connect(state => ({
  lineItemIds: selector(state, LINE_ITEMS)
}))(
  reduxForm({
    form: formName,
    onSubmit: async (data, _, props) => {
      await api.salesOrders.sendWeightDims(props.id, props.values).then(() => {
        props.setCurrentForm(SHIPPING_CHECKLIST);
        toastr.success(
          "Success",
          "Weight and Dims notification successfully sent."
        );
      });
    }
  })(SendWeightDimsForm)
);



// WEBPACK FOOTER //
// ./app/modules/Shipping/components/Dashboard/Create/SendWeightDimsForm.jsx